
up.compiler('[placeholder]', function(element) {
  const placeholderText = element.placeholder;

  function emptyPlaceholder(){
    element.placeholder = '';
  }

  function restorePlaceholder(){
    element.placeholder = placeholderText;
  }

  element.addEventListener('focus', emptyPlaceholder);
  element.addEventListener('blur', restorePlaceholder);

  return () => {
    element.removeEventListener('focus', emptyPlaceholder);
    element.removeEventListener('blur', restorePlaceholder);
  }
})